import React from "react";
import ConfigurableEntities from "./ConfigurableEntities";

export default function CustomMetadata() {
    return <ConfigurableEntities mode="metadata"/>;
}
